import { useLocation, useParams } from "react-router-dom";

import { useOffers } from "../hooks/useOffers";

import Button from "@/components/Button";
import OfferCard from "./OfferCard";

function OffersSection() {
    const { grade, school_level } = useParams();
    const currentRoute = useLocation();

    const filter = { field: "grade", value: grade };

    const include = [
        { field: "VideosDuration", value: "true" },
        { field: "VideosCount", value: "true" },
        { field: "QuizzesCount", value: "true" },
        { field: "StudentsCount", value: "true" },
        { field: "Discount", value: "true" },
    ];

    const includeFields = ["lectures", "lecturesCount", "lecturesExists"];

    const perPage = 2;

    const { isPending, offers } = useOffers({
        filter,
        include,
        includeFields,
        perPage,
    });

    if (isPending) return null;
    if (!offers?.data?.length && !isPending) {
        return null;
    }
    return (
        <section className="container flex flex-col items-center justify-center px-2 pb-4 mx-auto text-sm md:px-16 md:text-lg">
            <h2 className="self-start text-2xl md:text-4xl pt-14 text-secondary-color">
                احدث <span className="text-secondary-color">العروض </span>
            </h2>

            <div className="w-full">
                {/* {isPending && <PageSkeleton />} */}
                {offers?.data?.map((offer) => (
                    <OfferCard offer={offer} key={offer?.id} />
                ))}
            </div>
            <div className="py-5">
                {offers?.meta?.total > perPage &&
                    currentRoute.pathname === `/${school_level}/${grade}/courses` && (
                        <Button type="primary" to={`/${school_level}/${grade}/offers`}>
                            للمزيد من العروض
                        </Button>
                    )}
            </div>
        </section>
    );
}

export default OffersSection;
